import React, { useState } from "react";

const FeedbackForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("✅ Feedback submitted successfully!");
    console.log("Feedback Data:", formData);
    // TODO: API call to submit feedback
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-green-50 p-4">
      <div className="bg-white shadow-lg rounded-2xl p-6 w-full max-w-sm">
        {/* Title */}
        <h2 className="text-xl font-bold text-green-700 text-center mb-4">
          Feedback Form
        </h2>
        <p className="text-xs text-gray-500 text-center mb-6">
          Help us improve your attendance experience 📋
        </p>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Name */}
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg text-sm focus:ring-2 focus:ring-green-400"
            required
          />

          {/* Phone */}
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg text-sm focus:ring-2 focus:ring-green-400"
            required
          />

          {/* Message */}
          <textarea
            name="message"
            placeholder="Write your feedback..."
            value={formData.message}
            onChange={handleChange}
            rows="3"
            className="w-full p-3 border rounded-lg text-sm focus:ring-2 focus:ring-green-400 resize-none"
            required
          />

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-green-600 text-white py-3 rounded-lg text-sm font-semibold hover:bg-green-700 transition"
          >
            Submit Feedback
          </button>
        </form>
      </div>
    </div>
  );
};

export default FeedbackForm;
